export { default as Budget } from './TotalDevices';
export { default as LatestProducts } from './LatestProducts';
export { default as LatestSales } from './LatestSales';
export { default as TasksProgress } from './ActiesVandaag';
export { default as TotalUsers } from './TotalUsers';
export { default as UsersByDevice } from './UsersByDevice';